<template>
  <v-container fluid class="mt-16 px-6">
    <div class="">
      <v-card flat>
        <v-card-title class="d-flex">
          <h2 v-if="!isPhone">Accounts</h2>
          <v-spacer></v-spacer>
          <AddCustomerModal v-if="canAddCustomer" ref="addCustomerModal" />
          <v-btn
            color=""
            class=""
            icon
            x-large
            @click="refresh"
            :loading="loading"
            ><v-icon>mdi-refresh</v-icon></v-btn
          >
        </v-card-title>
        <v-tabs v-model="activeTab">
          <v-tab>
            <v-icon left small>mdi-account</v-icon>
            <span class="text-none">Active Accounts</span>
          </v-tab>
          <v-tab>
            <v-icon left small>mdi-account-off</v-icon>
            <span class="text-none">Deleted Accounts</span>
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="activeTab">
          <v-tab-item>
            <v-card-text>
              <v-text-field
                label="Search for something"
                v-model="search"
                prepend-inner-icon="mdi-magnify"
                placeholder="John Doe"
              ></v-text-field>
              <!-- Mobile: card list -->
              <div v-if="isPhone">
                <mobile-record-card
                  v-for="item in $mobileSearch(mappedCustomers, search)"
                  :key="item.id"
                  icon="mdi-account"
                  :icon-color="item.is_government == 1 ? 'blue' : 'primary'"
                  :title="item.customer_name"
                  :subtitle="item.customer_contact_no"
                  :fields="[
                    { label: 'TIN', value: item.display_tin },
                    { label: 'Municipality', value: item.customer_municipality },
                    { label: 'Barangay', value: item.customer_barangay },
                    { label: 'Added', value: formatted_date(item.created_at) },
                  ]"
                >
                  <template #chip>
                    <v-chip
                      v-if="item.is_government == 1"
                      x-small
                      color="blue"
                      dark
                      >Gov</v-chip
                    >
                  </template>
                  <template #actions>
                    <v-btn icon color="green" @click="openAddInvoice(item)">
                      <v-icon>mdi-receipt-text-plus</v-icon>
                    </v-btn>
                    <v-btn icon color="orange" @click="openDownPayment(item)">
                      <v-icon>mdi-cash-plus</v-icon>
                    </v-btn>
                    <EditCustomerModal :customer="item" v-if="canEditCustomer" />
                    <v-btn
                      icon
                      color="red"
                      @click="del(item)"
                      :loading="loading"
                      v-if="canDeleteCustomer"
                      ><v-icon>mdi-delete</v-icon></v-btn
                    >
                  </template>
                </mobile-record-card>
                <div
                  v-if="!$mobileSearch(mappedCustomers, search).length"
                  class="text-center text--secondary py-8"
                >
                  No accounts found.
                </div>
              </div>
              <!-- Desktop: data table -->
              <v-data-table
                v-else
                :search="search"
                class="mt-5"
                :items="mappedCustomers"
                :headers="headers"
                :loading="loading"
                dense
              >
                <template v-slot:item.created_at="{ item }">
                  {{ formatted_date(item.created_at) }}
                </template>
                <template v-slot:item.customer_name="{ item }">
                  <div class="d-flex align-center">
                    <span
                      :class="item.is_government == 1 ? 'blue--text' : ''"
                      >{{ item.customer_name }}</span
                    >
                  </div>
                </template>
                <template v-slot:item.actions="{ item }">
                  <div class="d-flex">
                    <!-- <v-btn icon @click="openAccount(item)" color="primary"
                  ><v-icon>mdi-account</v-icon></v-btn
                > -->
                    <v-btn
                      icon
                      @click="openAddInvoice(item)"
                      color="green"
                      title="Add Invoice"
                    >
                      <v-icon>mdi-receipt-text-plus</v-icon>
                    </v-btn>
                    <v-btn
                      icon
                      @click="openDownPayment(item)"
                      color="orange"
                      title="Add Down Payment"
                    >
                      <v-icon>mdi-cash-plus</v-icon>
                    </v-btn>
                    <EditCustomerModal
                      :customer="item"
                      v-if="canEditCustomer"
                    />
                    <v-btn
                      icon
                      color="red"
                      @click="del(item)"
                      :loading="loading"
                      v-if="canDeleteCustomer"
                      ><v-icon>mdi-delete</v-icon></v-btn
                    >
                  </div>
                </template>
              </v-data-table>
            </v-card-text>
          </v-tab-item>
          <v-tab-item>
            <v-card-text>
              <v-text-field
                label="Search for something"
                v-model="deletedSearch"
                prepend-inner-icon="mdi-magnify"
                placeholder="John Doe"
              ></v-text-field>
              <!-- Mobile: card list -->
              <div v-if="isPhone">
                <mobile-record-card
                  v-for="item in $mobileSearch(
                    mappedDeletedCustomers,
                    deletedSearch
                  )"
                  :key="item.id"
                  icon="mdi-account-off"
                  icon-color="grey"
                  :title="item.customer_name"
                  :subtitle="item.customer_contact_no"
                  :fields="[
                    { label: 'TIN', value: item.display_tin },
                    { label: 'Municipality', value: item.customer_municipality },
                    { label: 'Deleted', value: formatted_date(item.deleted_at) },
                  ]"
                >
                  <template #actions>
                    <v-btn icon color="success" @click="restore(item)">
                      <v-icon>mdi-restore</v-icon>
                    </v-btn>
                  </template>
                </mobile-record-card>
                <div
                  v-if="
                    !$mobileSearch(mappedDeletedCustomers, deletedSearch).length
                  "
                  class="text-center text--secondary py-8"
                >
                  No deleted accounts.
                </div>
              </div>
              <!-- Desktop: data table -->
              <v-data-table
                v-else
                :search="deletedSearch"
                class="mt-5"
                :items="mappedDeletedCustomers"
                :headers="deletedHeaders"
                :loading="loadingDeleted"
                dense
              >
                <template v-slot:item.deleted_at="{ item }">
                  {{ formatted_date(item.deleted_at) }}
                </template>
                <template v-slot:item.customer_name="{ item }">
                  <span :class="item.is_government == 1 ? 'blue--text' : ''">{{
                    item.customer_name
                  }}</span>
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-btn
                    icon
                    color="success"
                    @click="restore(item)"
                    title="Restore"
                  >
                    <v-icon>mdi-restore</v-icon>
                  </v-btn>
                </template>
              </v-data-table>
            </v-card-text>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </div>

    <!-- Add Invoice Card Component -->
    <add-invoice-card ref="addInvoiceCard" />

    <!-- Down Payments Modal Component -->
    <down-payments-modal ref="downPaymentsModal" />

    <!-- Mobile: floating Add Account -->
    <v-btn
      v-if="isPhone && canAddCustomer && activeTab === 0"
      fab
      fixed
      bottom
      right
      color="primary"
      class="mobile-fab"
      @click="$refs.addCustomerModal.dialog = true"
    >
      <v-icon>mdi-account-plus</v-icon>
    </v-btn>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import AddCustomerModal from "../components/Customer/addCustomerModal.vue";
import EditCustomerModal from "../components/Customer/editCustomerModal.vue";
import moment from "moment";
export default {
  data() {
    return {
      ready: false,

      selectedItem: "",
      enableCustomerModal: false,
      activeTab: 0,
      search: "",
      deletedSearch: "",
      loading: false,
      loadingDeleted: false,
      headers: [
        { text: "", value: "actions" },
        {
          text: "ID",
          value: "id",
        },

        { text: "Customer Name", value: "customer_name" },
        { text: "TIN", value: "display_tin" },
        { text: "Contact Number", value: "customer_contact_no" },
        { text: "Other Contact Platform", value: "other_contact_platform" },
        { text: "Customer Municipality", value: "customer_municipality" },
        { text: "Customer Barangay", value: "customer_barangay" },
        { text: "Customer Purok", value: "customer_purok" },

        { text: "Date Inserted", value: "created_at" },
      ],
      deletedHeaders: [
        { text: "", value: "actions" },
        {
          text: "ID",
          value: "id",
        },

        { text: "Customer Name", value: "customer_name" },
        { text: "TIN", value: "display_tin" },
        { text: "Contact Number", value: "customer_contact_no" },
        { text: "Other Contact Platform", value: "other_contact_platform" },
        { text: "Customer Municipality", value: "customer_municipality" },
        { text: "Customer Barangay", value: "customer_barangay" },
        { text: "Customer Purok", value: "customer_purok" },

        { text: "Deleted At", value: "deleted_at" },
      ],
      //   ['customer_name', 'customer_contact_no',
      //  'other_contact_platform', 'customer_municipality',
      //  'customer_barangay', 'customer_purok', 'where_did_you_find_us']
    };
  },
  computed: {
    ...mapGetters({
      customers: "customer/customers",
      deleted_customers: "customer/deleted_customers",
      user: "auth/user",
      hasPermission: "permission/hasPermission",
      user_permissions: "permission/user_permissions",
    }),
    // TIN is only meaningful for government accounts, so expose a derived
    // `display_tin` that is blank for non-government customers. This drives
    // both the column display and the table search (searching a TIN only
    // matches government accounts).
    mappedCustomers() {
      return (this.customers || []).map((c) => ({
        ...c,
        display_tin: c.is_government == 1 ? c.tin : "",
      }));
    },
    mappedDeletedCustomers() {
      return (this.deleted_customers || []).map((c) => ({
        ...c,
        display_tin: c.is_government == 1 ? c.tin : "",
      }));
    },
    // Permissions (hat bundles, managed on Role Restrictions) are the only
    // source of truth — accounts without hats get no access.
    canAddCustomer() {
      return this.hasPermission("accounts.add_customer");
    },
    canEditCustomer() {
      return this.hasPermission("accounts.edit_customer");
    },
    canDeleteCustomer() {
      return this.hasPermission("accounts.delete_customer");
    },
  },
  methods: {
    refresh() {
      this.loading = true;
      this.get_customers().then(() => {
        this.loading = false;
      });
    },
    formatted_date(date) {
      let x = moment(date).format("LL");

      return x;
    },
    async del(item) {
      this.loading = true;
      if (!this.canDeleteCustomer) {
        this.loading = false;
        this.$alert({
          title: "Error",
          message: "You are not allowed to do this.",
          color: "error",
          icon: "mdi-alert-circle",
        });
        return;
      }
      let x = await this.$confirm({
        title: "Delete Customer",
        message:
          "Are you sure you want to delete this customer? It will be moved to the Deleted Accounts tab and can be restored later.",
        color: "red",
        icon: "mdi-delete",
      });

      if (x) {
        this.delete_customer(item).then(() => {
          this.$alert({
            title: "Success",
            message: "Successfully deleted a customer",
            color: "success",
            icon: "mdi-check-circle",
          });
        });
      }
      this.loading = false;
    },
    async restore(item) {
      if (!this.canRestoreCustomer) {
        this.$alert({
          title: "Error",
          message: "You are not allowed to do this.",
          color: "error",
          icon: "mdi-alert-circle",
        });
        return;
      }
      let x = await this.$confirm({
        title: "Restore Customer",
        message: "Are you sure you want to restore this customer?",
        color: "success",
        icon: "mdi-restore",
      });

      if (x) {
        this.restore_customer(item).then(() => {
          this.$alert({
            title: "Success",
            message: "Successfully restored a customer",
            color: "success",
            icon: "mdi-check-circle",
          });
        });
      }
    },
    async fetch_deleted() {
      this.loadingDeleted = true;
      try {
        await this.get_deleted_customers();
      } finally {
        this.loadingDeleted = false;
      }
    },
    ...mapActions({
      get_customers: "customer/get_customers",
      delete_customer: "customer/delete_customer",
      get_deleted_customers: "customer/get_deleted_customers",
      restore_customer: "customer/restore_customer",
    }),
    checkCustomers() {
      if (!this.customers) return false;
      return true;
    },
    openAccount(item) {
      this.$router.push("account_profile/" + item.id);
      this.enableCustomerModal = true;
      this.selectedItem = item;
    },
    openAddInvoice(customer) {
      // Open the invoice dialog
      this.$refs.addInvoiceCard.dialog = true;

      // Wait for next tick to ensure the dialog is rendered
      this.$nextTick(() => {
        // Auto-select the customer account
        this.$refs.addInvoiceCard.select_account(customer);
      });
    },
    // Triggered by the global Quick Actions palette via ?quick= query param.
    handleQuickAction(action) {
      if (action === "add-client" && this.$refs.addCustomerModal) {
        this.$refs.addCustomerModal.dialog = true;
      }
      // Clear the query so the same action can be triggered again later.
      const query = { ...this.$route.query };
      delete query.quick;
      this.$router.replace({ query }).catch(() => {});
    },
    openDownPayment(customer) {
      // Open the down payment modal
      this.$refs.downPaymentsModal.dialog = true;

      // Wait for next tick to ensure the dialog is rendered
      this.$nextTick(() => {
        // Auto-select the customer
        this.$refs.downPaymentsModal.selectCustomer(customer);
      });
    },
  },
  watch: {
    // React to Quick Actions (Ctrl/Cmd + S) navigation while already on this page.
    "$route.query.quick": {
      immediate: true,
      handler(val) {
        if (val) this.$nextTick(() => this.handleQuickAction(val));
      },
    },
  },
  async created() {
    this.loading = true;
    if (this.customers.length == 0) {
      await this.get_customers();
    }
    this.loading = false;
    this.fetch_deleted();
  },
  components: {
    AddCustomerModal,
    EditCustomerModal,
    AddInvoiceCard: () => import("@/components/Invoice/addInvoiceCard.vue"),
    DownPaymentsModal: () =>
      import("@/components/Invoice/downPaymentsModal.vue"),
  },
};
</script>

<style lang="scss" scoped></style>
